module.exports = __webpack_public_path__ + "img/success.d13aef08.svg";